import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const mobileSystemFooterStyles: SxProps<Theme> = {
	position: 'sticky',
	bottom: 0,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	height: '56px',
	p: '12px 24px',
	backgroundColor: Colors.black_a80,
	borderTop: `1px solid ${Colors.white_a10}`,
	backdropFilter: 'blur(10px)',
};
